ScrollTrigger.defaults({
    markers: false,
});

(function(){
    // コンテナ要素とスライド要素を取得
    const wrapper = document.querySelector("#cat-category");
    if(null === wrapper) return;
    const slides = gsap.utils.toArray(".bl_categorybelt_item");
    let mm = gsap.matchMedia();

    // コンテナの幅を取得
    const wrapperWidth = wrapper.offsetWidth;

    mm.add("(max-width: 807px)", () => {
        const delay = .2;
        $(".bl_categorybelt_item").each(function(i){
            gsap.fromTo(
                this,
                {autoAlpha: 0,y:10,scale:.95},
                {
                    delay: (i%2 !== 0) ? delay : 0,
                    autoAlpha: 1,y:0,scale:1,
                    scrollTrigger: {
                        trigger: this,
                        start: "top center+=20%",
                        toggleActions: 'restart none none none', // onEnter, onLeave, onEnterBack, onLeaveBack
                        onLeaveBack: progress => {
                            gsap.to(progress.trigger, {
                                delay: (0 === progress.animation._delay) ? delay : 0,
                                autoAlpha: 0,y:10,scale:.95
                            })
                        },
                    },
                }
            );
        });
    });

    mm.add("(min-width: 808px)", () => {
        const itemInner = document.querySelector('.bl_categorybelt_list:nth-child(1)');
        if(null === itemInner) return;
        gsap.set(itemInner, {
            x:wrapperWidth * 1.2, // スタート位置
            y:'10%', // スタート位置
            scale:2
        });
        function categorybelt_x(itemInner){
            return (window.innerWidth > 2048) ? -2048 : -(itemInner.clientWidth*1.3);
        }
        gsap.to(itemInner, {
        x: () => `${categorybelt_x(itemInner)}`, // 終了位置
        ease: 'none',
        scrollTrigger: {
            trigger: '#cat-category .bl_partition__category', 
            start: 'top top',
            end: () => `+=${itemInner.clientWidth}`,
            scrub: .5, 
            pin: true,  
            invalidateOnRefresh: true, 
            anticipatePin: 1,
            onUpdate: e => {
            },
            onEnter: progress => {
                document.querySelector('#cat-category .bl_categorybelt').classList.add('scrolled');

                gsap.to(".ly_header",{
                    y:"-100%", opacity: 0, duration: .5
                })
            },
            onEnterBack: progress => {
                document.querySelector('#cat-category .bl_categorybelt').classList.add('scrolled');

                gsap.to(".ly_header",{
                    y:"-100%", opacity: 0, duration: .5
                })
            },
            onLeave: progress => {
                document.querySelector('#cat-category .bl_categorybelt').classList.remove('scrolled');

                gsap.to(".ly_header",{
                  y:"0%", opacity: 1, duration: .5,
                })
            },
            onLeaveBack: progress => {
                document.querySelector('#cat-category .bl_categorybelt').classList.remove('scrolled');

                gsap.to(".ly_header",{
                    y:"0%", opacity: 1, duration: .5,
                })
            },
        },
        });
    });
})();
/**
 * StyleBox
 */
(function(){
    var Timer_style, animated_flag_style = false;
    var tl = gsap.timeline(), tl2 = gsap.timeline();
    gsap.set($('.bl_stylebox_container .bl_stylebox_item'), {
        x: 30,
        opacity: 0,
    });
    gsap.set($('.ly_container__stylebox .bl_stylebox_figure'), {
        x: -30,
        y: 10,
        opacity: 0,
    });
    $('.bl_stylebox_container').parents('.ly_container').each(function(){
        $container = $(this);
        const itemInner = document.querySelector('.bl_stylebox_container');
        $(itemInner).addClass('is-deactive');
        gsap.to($container, {
            ease: 'none',
            scrollTrigger: {
                trigger: $container, 
                start: '-50% top',
                onUpdate: e => {
                },
                onComplete: e => {
                    tl.pause();
                    tl2.pause();
                },
                onEnter: progress => {
                    $(itemInner).removeClass('is-deactive');
                    tl.restart();
                    tl2.restart();
                    var item = $(itemInner).find('.bl_stylebox_item');
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            opacity: 1,
                            duration: .8,
                            delay: -.6 * d,
                        })
                        tl.to(this, {
                            x: 0,
                            duration: .8,
                            delay: -1,
                        })
                    });
                    var f = $container.find('.bl_stylebox_figure');
                    tl2.to(f, {
                        opacity: 1,
                        duration: 1.5,
                        delay: .8,
                    })
                    tl2.to(f, {
                        x: 0,
                        y: 0,
                        duration: .5,
                        delay: -1.3,
                    })
                },
                onLeaveBack: progress => {
                    tl.pause();
                    tl2.pause();
                    gsap.to($(itemInner).find('.bl_stylebox_item'), {
                        x: 30,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    gsap.to($container.find('.bl_stylebox_figure'), {
                        x: -30,
                        y: 10,
                        opacity: 0,
                        duration:.5
                    });
                    $(itemInner).addClass('is-deactive');
                },
            },
        });
    });
    $('.bl_stylebox_item').on({
        mouseover: function(e) {
            clearTimeout(Timer_style);
            $this = $(this);
            Timer_style = setTimeout(function(){
                const parent = $this.parents('.bl_stylebox');
                const name = $this.attr('data-collectionname');
                const target = parent.find('.bl_stylebox_figure_item-' + name);
                if(target.is(':visible')) return;
                animated_flag_style = true; // アニメーション中のフラグを立てる
                var Timeline_style = gsap.timeline();
                parent.find('.bl_stylebox_figure_item:visible').each(function(i){
                    duration = .8, delay = -0.6*i;
                    duration = 0, delay = 0;
                    gsap.set(this, {
                        // y:'0',
                        opacity:1
                    });
                    Timeline_style.to(this, {
                        // y:10,
                        opacity:0,
                        duration:duration,
                        delay:delay,
                        onComplete:function(){
                            $(this._targets).hide();
                        }
                    });
                });
                target.show();
                target.each(function(i){
                    duration = .8, delay = -.8+0.2*(i + 1);
                    duration = 0, delay = 0;
                    gsap.set(this, {
                        //y:12,
                        opacity:0
                    });
                    Timeline_style.to(this, {
                        // y:0,
                        opacity:1,
                        duration:duration,
                        delay:delay
                    });
                });
                Timeline_style.to(this, {onComplete:function(){
                    // タイムラインの最後にフラグを折る
                    animated_flag_style = false;
                }});
                Timeline_style.play();
            },30)
        }
    })
    let mm = gsap.matchMedia();
    if(null !== document.querySelector(".bl_stylebox_bg.splide")) {
        mm.add("(max-width: 768px)", () => {
            new Splide(".bl_stylebox_bg.splide", {
              type: 'fade',
              rewind: true, // 最後に到達した後、最初に戻る
              perPage: 1, // 表示するスライド枚数
              autoplay: true,
              pauseOnHover: false,
              pauseOnFocus: false,
              cover: false,
              arrows: false,
              pagination: false,
              padding: 0,
              mediaQuery: 'min',
              speed: 1000,
              interval: 5000,
              breakpoints: {
                  750: {
                  type   : 'fade',
                  focus  : 'center',
                  perPage: 1,
                  padding: '0',
                  },
              },
            }).mount();
        });
    }
})();


/**
 * TOP bl_blog
 */
(function(){
    let mm = gsap.matchMedia();
    mm.add("(max-width: 768px)", () => {
        const wrapper = document.querySelector('.b_archiveList');
        const item = $(wrapper).find('.b_archiveList_item');
        gsap.set(item, {
            opacity:0,
            y: 10
        });
        item.each(function(i){
            gsap.to(this, {
                y: 0,
                opacity: 1,
                duration: .8,
                scrollTrigger: {
                    trigger: this,
                    start: "top center",
                },
            });
        });
    });
    mm.add("(min-width: 769px)", () => {
        const wrapper = document.querySelector('.ly_container__blog');
        const item = $(wrapper).find('.ly_grid_col');
        $(wrapper).addClass('is-deactive');
        gsap.set(item, {
            opacity:0,
            y: 10
        });
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: '-50% top',
                onEnter: progress => {
                    $(wrapper).removeClass('is-deactive');
                    var tl = gsap.timeline();
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            duration: .8,
                            delay: -.6 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    $(wrapper).addClass('is-deactive');
                },
            },
        });
    });
})();

/**
 * TOP ly_container__restoration
 */
(function(){
    const wrapper = document.querySelector('.ly_container__restoration');
    const item = $(wrapper).find('> *');
    gsap.set(item, {
        y: 10,
        opacity: 0,
        scale:1,
    });
    $(wrapper).addClass('is-deactive');
    let mm = gsap.matchMedia();
    mm.add("(max-width: 807px)", () => {
    });
    mm.add("(min-width: 808px)", () => {
    });
    mm.add("(max-width: 807px)", () => {
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: '-70% 50%',
                onEnter: progress => {
                    $(wrapper).removeClass('is-deactive');
                    var tl = gsap.timeline();
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            duration: .8,
                            delay: -.6 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    $(wrapper).addClass('is-deactive');
                },
            },
        });
    });
    mm.add("(min-width: 808px)", () => {
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: '-50% top',
                onEnter: progress => {
                    $(wrapper).removeClass('is-deactive');
                    var tl = gsap.timeline();
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            duration: .8,
                            delay: -.6 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    $(wrapper).addClass('is-deactive');
                },
            },
        });
    });
})();

/**
 * TOP bl_process
 */
(function(){
    $('.bl_process .ly_container .ly_grid, .bl_support .ly_container .ly_grid, .bl_about .ly_container .ly_grid').each(function(){
        const wrapper = this, parent = $(wrapper).parents('.ly_container').parent();
        const item = $(wrapper).find('> *');
        gsap.set(item, {
            y: 10,
            opacity: 0,
            scale:1,
        });
        parent.addClass('is-deactive');
        $(wrapper).addClass('is-deactive');
        let mm = gsap.matchMedia();
        mm.add("(max-width: 807px)", () => {
            gsap.to(wrapper, {
                ease: 'none',
                scrollTrigger: {
                    trigger: wrapper, 
                    start: '-70% 50%',
                    onEnter: progress => {
                        parent.removeClass('is-deactive');
                        var tl = gsap.timeline();
                        item.each(function(i){
                            const d = (i > 0) ? 1 : 0;
                            tl.to(this, {
                                y: 0,
                                opacity: 1,
                                scale:1,
                                duration: .8,
                                delay: -.6 * d,
                            })
                        });
                    },
                    onLeaveBack: progress => {
                        gsap.to(item, {
                            y: 10,
                            opacity: 0,
                            scale:1,
                            duration:.5
                        });
                        parent.addClass('is-deactive');
                    },
                },
            });
        });
        mm.add("(min-width: 808px)", () => {
            gsap.to(wrapper, {
                ease: 'none',
                scrollTrigger: {
                    trigger: wrapper, 
                    start: '-50% top',
                    onEnter: progress => {
                        parent.removeClass('is-deactive');
                        var tl = gsap.timeline();
                        item.each(function(i){
                            const d = (i > 0) ? 1 : 0;
                            tl.to(this, {
                                y: 0,
                                opacity: 1,
                                scale:1,
                                duration: .8,
                                delay: -.6 * d,
                            })
                        });
                    },
                    onLeaveBack: progress => {
                        gsap.to(item, {
                            y: 10,
                            opacity: 0,
                            scale:1,
                            duration:.5
                        });
                        parent.addClass('is-deactive');
                    },
                },
            });
        });
    });
})();

/**
 * TOP bl_social
 */
(function(){
    console.log($('#insta-feed').length);
    if(!$('#insta-feed').length) return;
    if($('#insta-feed').parents('.shopify-section').length) {
        $('.bl_title__instagram').parents('.bl_social').css({zIndex:1});
        $('.bl_title__instagram, #insta-feed, .el_btn__follow').each(function(){
            const wrapper = $(this).parent(), parent = $(wrapper).parents('.shopify-section');
            const item = $(wrapper).find('> *');
            gsap.set(item, {
                y: 10,
                opacity: 0,
                scale:1,
            });
            parent.addClass('is-deactive');
            $(wrapper).addClass('is-deactive');
            let mm = gsap.matchMedia();
            mm.add("(max-width: 807px)", () => {
                gsap.to(wrapper, {
                    ease: 'none',
                    scrollTrigger: {
                        trigger: wrapper, 
                        start: '-70% 50%',
                        onEnter: progress => {
                            parent.removeClass('is-deactive');
                            var tl = gsap.timeline();
                            item.each(function(i){
                                const d = (i > 0) ? 1 : 0;
                                tl.to(this, {
                                    y: 0,
                                    opacity: 1,
                                    scale:1,
                                    duration: .8,
                                    delay: -.6 * d,
                                })
                            });
                        },
                        onLeaveBack: progress => {
                            gsap.to(item, {
                                y: 10,
                                opacity: 0,
                                scale:1,
                                duration:.5
                            });
                            parent.addClass('is-deactive');
                        },
                    },
                });
            });
            mm.add("(min-width: 808px)", () => {
                gsap.to(wrapper, {
                    ease: 'none',
                    scrollTrigger: {
                        trigger: wrapper, 
                        start: '-50% 50%',
                        onEnter: progress => {
                            parent.removeClass('is-deactive');
                            var tl = gsap.timeline();
                            item.each(function(i){
                                const d = (i > 0) ? 1 : 0;
                                tl.to(this, {
                                    y: 0,
                                    opacity: 1,
                                    scale:1,
                                    duration: .8,
                                    delay: -.6 * d,
                                })
                            });
                        },
                        onLeaveBack: progress => {
                            gsap.to(item, {
                                y: 10,
                                opacity: 0,
                                scale:1,
                                duration:.5
                            });
                            parent.addClass('is-deactive');
                        },
                    },
                });
            });
        });
    }
    
})();

/**
 * Restoration
 */
(function(){
    $('.b_restorationIntro_mainInner').each(function(){
        const wrapper = this, parent = $(wrapper).parents('.l_restoration_intro');
        const item = $(wrapper).find('> *');
        gsap.set(item, {
            y: 10,
            opacity: 0,
            scale:1,
        });
        parent.addClass('is-deactive');
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: '-100% top',
                onEnter: progress => {
                    parent.removeClass('is-deactive');
                    var tl = gsap.timeline();
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            scale:1,
                            duration: 1.2,
                            delay: -.8 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    parent.addClass('is-deactive');
                },
            },
        });
    });

    $('.l_restoration_flow .b_restorationFlow').each(function(){
        const wrapper = this, parent = $(wrapper).parents('.l_restoration_flow');
        const item = $(wrapper).find('> *');
        gsap.set(item, {
            y: 10,
            opacity: 0,
            scale:1,
        });
        parent.addClass('is-deactive');
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: '-100% top',
                onEnter: progress => {
                    parent.removeClass('is-deactive');
                    var tl = gsap.timeline();
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            scale:1,
                            duration: .3,
                            delay: -.1 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.2
                    });
                    parent.addClass('is-deactive');
                },
            },
        });
    });

    $('.b_afterService_inner').each(function(){
        const wrapper = this, parent = $(wrapper).parents('.l_restoration_after');
        const item = $(wrapper).find('> *');
        gsap.set(item, {
            y: 10,
            opacity: 0,
            scale:1,
        });
        parent.addClass('is-deactive');
        const headline = parent.find('.e_restoration_ttl');
        gsap.set(headline, {
            y: 10,
            opacity: 0,
            scale:1,
        });
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: '-100% top',
                onEnter: progress => {
                    parent.removeClass('is-deactive');
                    var tl = gsap.timeline();
                    tl.to(headline, {
                        y: 0,
                        opacity: 1,
                        scale:1,
                        duration: .3,
                    });
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            scale:1,
                            duration: 1.2,
                            delay: -.8 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(headline, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration: .3,
                    });
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    parent.addClass('is-deactive');
                },
            },
        });
    });
})();

/**
 * About
 */
(function(){
    $('.bl_breadcrumbs + .ly_container .bl_title').each(function(){
        const wrapper = this, parent = $(wrapper).parent();
        const item = $(wrapper).find('> *');
        gsap.set(item, {
            y: 10,
            opacity: 0,
            scale:1,
        });
        parent.addClass('is-deactive');
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: '-150% top',
                onEnter: progress => {
                    parent.removeClass('is-deactive');
                    var tl = gsap.timeline();
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            scale:1,
                            duration: 1.2,
                            delay: -.8 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    parent.addClass('is-deactive');
                },
            },
        });
    });
    $('.bl_company, .ly_container__about_hero').each(function(){
        const wrapper = this, parent = $(wrapper).parent();
        const item = $(wrapper).find('> *');
        gsap.set(item, {
            y: 10,
            opacity: 0,
            scale:1,
        });
        parent.addClass('is-deactive');
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: '-150% top',
                onEnter: progress => {
                    parent.removeClass('is-deactive');
                    var tl = gsap.timeline();
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            scale:1,
                            duration: 1.2,
                            delay: -.8 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    parent.addClass('is-deactive');
                },
            },
        });
    });
    $('.bl_contact').each(function(){
        const wrapper = this, parent = $(wrapper).parent();
        const item = $(wrapper).find('> *');
        gsap.set(item, {
            y: 10,
            opacity: 0,
            scale:1,
        });
        parent.addClass('is-deactive');
        gsap.to(wrapper, {
            ease: 'none',
            scrollTrigger: {
                trigger: wrapper, 
                start: 'top 80%',
                onEnter: progress => {
                    parent.removeClass('is-deactive');
                    var tl = gsap.timeline();
                    item.each(function(i){
                        const d = (i > 0) ? 1 : 0;
                        tl.to(this, {
                            y: 0,
                            opacity: 1,
                            scale:1,
                            duration: 1.2,
                            delay: -.8 * d,
                        })
                    });
                },
                onLeaveBack: progress => {
                    gsap.to(item, {
                        y: 10,
                        opacity: 0,
                        scale:1,
                        duration:.5
                    });
                    parent.addClass('is-deactive');
                },
            },
        });
    });
})();


/**
 * Blog
 */
(function(){
    $('.l_archive_blog').each(function () {
        gsap.fromTo($(this).find('.l_archive_blogTtl'), {
            y: 10,
            opacity: 0,
            scale: 1,
        }, {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: 1.2,
        });

        var tl = gsap.timeline();
        $(this).find('.b_sidebar').each(function () {
            const wrapper = this, parent = $(wrapper).parent();
            const item = $(wrapper).find('> *');
            gsap.set(item, {
                y: 10,
                opacity: 0,
                scale: 1,
            });
            parent.addClass('is-deactive');
            gsap.to(wrapper, {
                ease: 'none',
                scrollTrigger: {
                    trigger: wrapper,
                    start: '-150% top',
                    onEnter: progress => {
                        parent.removeClass('is-deactive');
                        item.each(function (i) {
                            const d = (i > 0) ? 1 : 0;
                            tl.to(this, {
                                y: 0,
                                opacity: 1,
                                scale: 1,
                                duration: .4,
                                delay: -.2 * d,
                            })
                        });
                    },
                    onLeaveBack: progress => {
                        gsap.to(item, {
                            y: 10,
                            opacity: 0,
                            scale: 1,
                            duration: .5
                        });
                        parent.addClass('is-deactive');
                    },
                },
            });
        });

        $(this).find('.b_archiveList_itemInner, .b_singleBlog').each(function () {
            const wrapper = this, parent = $(wrapper).parent();
            const item = $(wrapper).find('> *');
            gsap.set(item, {
                y: 10,
                opacity: 0,
                scale: 1,
            });
            parent.addClass('is-deactive');
            gsap.to(wrapper, {
                ease: 'none',
                scrollTrigger: {
                    trigger: wrapper,
                    start: '-300% top',
                    onEnter: progress => {
                        parent.removeClass('is-deactive');
                        item.each(function (i) {
                            const d = (i > 0) ? 1 : 0;
                            tl.to(this, {
                                y: 0,
                                opacity: 1,
                                scale: 1,
                                duration: .5,
                                delay: -.3 * d,
                            })
                        });
                    },
                },
            });
        });
    });
})();


/**
 * 商品一覧・詳細
 */
(function(){
    var tl = gsap.timeline();
    gsap.set($('.ly_container__item_list > .bl_showcase > *'), {
        y: 10,
        opacity: 0,
        scale: 1,
    });
    $('.ly_container__item_list > *').each(function () {
        tl.fromTo($(this), {
            y: 10,
            opacity: 0,
            scale: 1,
        }, {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: .8,
            delay: -.5,
        });
        if($(this).hasClass('bl_showcase')) {
            $(this).find('> *').each(function (i) {
                const d = (i > 0) ? 1 : 1.8;
                tl.to($(this), {
                    y: 0,
                    opacity: 1,
                    scale: 1,
                    duration: .7,
                    delay: -.4 * d,
                });
            });
        }
    });

    $('.l_products_topImg > *').each(function () {
        tl.fromTo($(this), {
            y: 10,
            opacity: 0,
            scale: 1,
        }, {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: .8,
            delay: -.4,
        });
    });
    $('.l_products_topInfo .b_productsInfo > *').each(function () {
        tl.fromTo($(this), {
            y: 10,
            opacity: 0,
            scale: 1,
        }, {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: .5,
            delay: -.3,
        });
    });

    item = $('.l_products_desc > .l_wrap > .b_productsDesc');
    gsap.set(item, {
        y: 10,
        opacity: 0,
        scale:1,
    });
    gsap.set(item.parent().find('.b_productsDesc_table'), {
        y: 10,
        opacity: 0,
        scale:1,
    });
    gsap.to(item, {
        ease: 'none',
        scrollTrigger: {
            trigger: '.l_products_desc', 
            start: 'top center',
            onEnter: progress => {
                var tl = gsap.timeline();
                item.each(function(i){
                    const d = (i > 0) ? 1 : 0;
                    tl.to(this, {
                        y: 0,
                        opacity: 1,
                        scale:1,
                        duration: 1.2,
                        delay: -.8 * d,
                    })
                });
                tl.to(item.parent().find('.b_productsDesc_table'), {
                    y: 0,
                    opacity: 1,
                    scale:1,
                    duration: 1.2,
                    delay: -.8,
                })
            },
            onLeaveBack: progress => {
                gsap.to(item, {
                    y: 10,
                    opacity: 0,
                    scale:1,
                    duration:.5
                });
                gsap.set(item.parent().find('.b_productsDesc_table'), {
                    y: 10,
                    opacity: 0,
                    scale:1,
                    duration:.5
                });
                parent.addClass('is-deactive');
            },
        },
    });
})();
